import { render, staticRenderFns } from "./NotificationsMessageFromTalentListItem.vue?vue&type=template&id=4d9c849e&scoped=true&"
import script from "./NotificationsMessageFromTalentListItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationsMessageFromTalentListItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsMessageFromTalentListItem.vue?vue&type=style&index=0&id=4d9c849e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9c849e",
  null
  
)

/* custom blocks */
import block0 from "./NotificationsMessageFromTalentListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports